











































































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component} from "vue-property-decorator";
import SaleSearch from "@/modules/sale/List/components/Search.vue";
import {SaleStore} from "@/modules/sale/store";
import {SaleParams} from "@/modules/sale/params";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";
import SaleTableAction from "@/modules/sale/List/components/TableAction.vue";
import CommonStatusLabel from "@/shared/components/CommonStatusLabel/index.vue";


const columns = [
    {
        title: "Thao tác",
        dataIndex: "id",
        key: "id",
        width: 100,
        scopedSlots: { customRender: "action" },
        align: 'center',
        fixed: 'left',
        ellipsis: true
    },
    {
        title: "Tên đơn vị",
        dataIndex: "customerName",
        key: "customerName",
        scopedSlots: { customRender: "customerName" },
        width: 200,
        align: 'center',
        fixed: 'left',
        ellipsis: true
    },
    {
        title: "Địa chỉ giao dịch",
        dataIndex: "address",
        key: "address",
        scopedSlots: { customRender: "address" },
        width: 200,
        align: 'center',
        ellipsis: true
    },
    {
        title: "Yêu cầu dịch vụ",
        dataIndex: "serviceRequest",
        key: "name",
        width: 200,
        ellipsis: true
    },
    {
        title: "Phản hồi của khách hàng",
        dataIndex: "customerResponse",
        key: "customerResponse",
        width: 150,
        ellipsis: true
    },
    {
        title: "Người liên hệ",
        dataIndex: "contact",
        key: "contact",
        width: 150,
        scopedSlots: { customRender: "contact" },
        ellipsis: true
    },
    {
        title: "Số điện thoại",
        dataIndex: "phoneNumber",
        key: "phoneNumber",
        width: 150,
        scopedSlots: { customRender: "phoneNumber" },
        ellipsis: true
    },
    {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: 150,
        scopedSlots: { customRender: "email" },
        ellipsis: true
    },
    {
        title: "Ngành nghề KD",
        dataIndex: "businessLine",
        key: "businessLine",
        width: 150,
        scopedSlots: { customRender: "businessLine" },
        ellipsis: true
    },
    {
        title: "Đối thủ cạnh trạnh",
        dataIndex: "competitors",
        key: "competitors",
        width: 150,
        scopedSlots: { customRender: "competitors" },
        ellipsis: true
    },
    {
        title: "Doanh thu (UT)",
        dataIndex: "estimatedRevenue",
        key: "estimatedRevenue",
        width: 150,
        scopedSlots: { customRender: "estimatedRevenue" },
        ellipsis: true
    },
    {
        title: "Phiên bản báo giá",
        dataIndex: "quotationVersion",
        key: "quotationVersion",
        width: 150,
        scopedSlots: { customRender: "quotationVersion" },
        ellipsis: true
    },
    {
        title: "Ngày báo giá",
        dataIndex: "quotationDate",
        key: "quotationDate",
        width: 150,
        scopedSlots: { customRender: "quotationDate" },
        ellipsis: true
    },
    {
        title: "Ngày CSKH gần nhất",
        dataIndex: "lastSupportDate",
        key: "lastSupportDate",
        width: 150,
        scopedSlots: { customRender: "lastSupportDate" },
        ellipsis: true
    },
    {
        title: "Người tạo",
        dataIndex: "createdBy.employee.fullname",
        key: "createByName",
        width: 150,
        scopedSlots: { customRender: "createByName" },
        ellipsis: true
    },
    {
        title: "NVKD chăm sóc",
        dataIndex: "employee.name",
        key: "employee",
        width: 150,
        scopedSlots: { customRender: "employee" },
        ellipsis: true
    },
    {
        title: "Ngày giờ tạo",
        dataIndex: "createdDate",
        key: "createdDate",
        width: 150,
        scopedSlots: { customRender: "createdDate" },
        ellipsis: true
    },
    {
        title: "Trạng thái",
        dataIndex: "status",
        key: "status",
        width: 150,
        scopedSlots: { customRender: "status" },
        ellipsis: true
    }
]
@Component({
    name: "SaleList",
    components: {CommonStatusLabel, SaleTableAction, TooltipLabel, SaleSearch}
})
export default class extends mixins(CommonMixin){
    columns = [...columns];
    
    created() {
        const params = new SaleParams();
        SaleStore.updateParams(params);
        SaleStore.listSale(params);
    }
    
    get sales() {
        return Object.values(SaleStore.data);
    }
    
    get pagination() {
        return {
            current: SaleStore.meta.page,
            pageSize: SaleStore.meta.limit,
            total: SaleStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} Sales`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }
    
    onChangePage(pagination: any) {
        SaleStore.listSale({...SaleStore.params, page: pagination.current, limit: pagination.pageSize});
    }
    
    async onConfirm(id: any) {
        try {
            await SaleStore.deleteSale(id);
            this.$message.success("Xóa thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Xóa thất bại");
        }
    }
    
}
